var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"svg-icon",attrs:{"viewBox":_vm.icons[_vm.name].viewBox || '0 0 24 24',"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.icons[_vm.name].content)}})}
var staticRenderFns = []

export { render, staticRenderFns }